// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"959fc582","453":"c54b47e9","455":"7be9c125","644":"e55d780e"}[chunkId] + ".chunk.js";
};